<template>
    <div>
        <div class="guest-logo">
            <img
                src="/images/logo.png"
                alt="goTenna Pro Management Portal"
            />
            <span
                v-if="$store.getters['environmentNameSafe']"
                class="environment-name"
            >
                {{ $store.getters['environmentNameSafe'] }}
            </span>
        </div>

        <div class="module form-module">
            <header class="module__header">
                <h1>Login</h1>
            </header>

            <section class="module__body">
                <form @submit.prevent="login">
                    <div class="form-group">
                        <label for="organization">Organization</label>
                        <input
                            id="organization"
                            ref="organization"
                            v-model="organization"
                            type="text"
                            maxlength="32"
                        />
                    </div>

                    <div class="form-group">
                        <label for="email">Email</label>
                        <input
                            id="email"
                            v-model="email"
                            type="email"
                            required
                            maxlength="255"
                        />
                    </div>

                    <div class="form-group">
                        <label for="password">Password</label>
                        <input
                            id="password"
                            v-model="password"
                            type="password"
                            required
                            maxlength="255"
                        />
                    </div>

                    <form-errors :response="errorResponse"></form-errors>

                    <div class="form-group">
                        <router-link
                            to="/forgot-password"
                            tag="a"
                            class="forgot-password"
                            data-test-id="login-forgot-password-link"
                        >
                            Forgot Password?
                        </router-link>

                        <button
                            type="submit"
                            class="btn btn-primary"
                            :class="{ active: submitted }"
                        >
                            <div>Login</div>
                        </button>
                    </div>
                </form>
            </section>
        </div>
    </div>
</template>

<script>
import FormErrors from '@/components/FormErrors.vue'

export default {
    components: {
        FormErrors,
    },

    props: {
        registrationToken: {
            type: Object,
            required: false,
        },
    },

    data() {
        return {
            organization: null,
            email: null,
            password: null,
            errorResponse: null,
            submitted: false,
        }
    },

    mounted() {
        this.$nextTick(() => this.$refs.organization.focus())
    },

    methods: {
        login() {
            this.submitted = true
            this.$store
                .dispatch('login', {
                    organization: this.organization,
                    email: this.email,
                    password: this.password,
                    registration_token: this.registrationToken,
                })
                .then(() => {
                    this.$router.push('/')
                })
                .catch((error) => {
                    this.errorResponse = error.response
                    this.submitted = false
                })
        },
    },
}
</script>

<style scoped>
.forgot-password {
    font-size: 0.875rem;
    position: relative;
    top: 12px;
}
</style>
